<template lang="pug">
  sui-container
    transition(name="fade")
      sui-dimmer(
        inverted,
        active,
        v-if="loading")
        sui-loader Loading...

    app-statistics(
      v-if="!loading",
      :stats="stats")

    standing-table(
      v-if="!loading",
      :teams="teams")
</template>

<script>
import AppStatistics from '@/components/home/AppStatistics.vue';
import StandingTable from '@/components/home/StandingTable.vue';

export default {
  name: 'Home',
  components: {
    AppStatistics,
    StandingTable,
  },
  computed: {
    loading() {
      return this.$store.state.loading;
    },
    teams() {
      const comparator = (a, b) => a.standings.league.placement - b.standings.league.placement;

      return this.$store.state.teams.slice(0).sort(comparator);
    },
    stats() {
      const stats = [];

      const matches = this.$store.state.matches;
      stats.push({
        label: 'Matches',
        value: matches.length,
      });

      stats.push({
        label: 'Teams',
        value: this.$store.state.teams.length,
      });

      stats.push({
        label: 'Players',
        value: this.$store.state.players.length,
      });

      return stats;
    },
  },
};
</script>
